import React from 'react';
import * as echarts from 'echarts';
import EchartsReactCore from './core';

// import data from './theme.json'

// Create a functional component
const EchartsReact = (props) => {
  // Register the theme if needed
  // echarts.registerTheme('customed', data);

  // Return the EchartsReactCore component with the necessary props
  return <EchartsReactCore {...props} echarts={echarts} />;
};

export default EchartsReact;